"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const framer_motion_1 = require("framer-motion");
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const constants_1 = __importStar(require("@/constants"));
const redux_1 = require("@/redux");
const selectors_1 = __importDefault(require("@/selectors"));
const index_1 = __importStar(require("../../layouts/index"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const StepLayout = ({ close, sessionStepTwo, payload, layout, user, isTherapySession, selectNextStep, currentStepId, }) => {
    const Layout = index_1.default[layout] || null;
    let layoutProps = {};
    const { caseManager, therapist } = user;
    const { type } = payload;
    const caregiver = type === "caseManagement" ? caseManager : therapist;
    const hasCaregiver = !lodash_1.isEmpty(caregiver.caregiver);
    if (layout === index_1.LAYOUTS.SESSION_STEP_ONE || layout === index_1.LAYOUTS.SESSION_STEP_TWO) {
        layoutProps = {
            caregiver,
            type,
            hasCaregiver,
        };
    }
    if (layout === index_1.LAYOUTS.PROCESS_QUESTIONS) {
        const pqPayload = payload;
        const { questions, programId, sectionId, processQuestionId } = pqPayload;
        layoutProps = {
            questions,
            programId,
            sectionId,
            processQuestionId,
        };
    }
    if (layout === index_1.LAYOUTS.PROCESS_QUESTIONS_SUMMARY) {
        const pqsPayload = payload;
        const { questions } = pqsPayload;
        layoutProps = {
            questions,
        };
    }
    return (core_1.jsx(framer_motion_1.motion.div, { className: styles_scss_1.default.stepContainerLayout, initial: { opacity: 0, y: 300 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0 } },
        core_1.jsx("div", { className: styles_scss_1.default.header },
            core_1.jsx("button", { className: styles_scss_1.default.closeBtn, css: styles_1.default.layoutCloseBtn(constants_1.Images.greyClose), onClick: () => close(), type: "button" }),
            core_1.jsx("h3", null, isTherapySession ? constants_1.default.program.sessionType[type] : constants_1.default.program.processQuestions)),
        Layout ? (
        // @ts-ignore
        core_1.jsx(Layout, Object.assign({ onContinue: () => {
                if (layout === index_1.LAYOUTS.SESSION_STEP_ONE) {
                    if (!hasCaregiver) {
                        close();
                        return;
                    }
                    sessionStepTwo();
                }
                if (layout === index_1.LAYOUTS.SESSION_STEP_TWO ||
                    layout === index_1.LAYOUTS.PROCESS_QUESTIONS_SUMMARY) {
                    close();
                }
                if (layout === index_1.LAYOUTS.PROCESS_QUESTIONS_FINISH) {
                    selectNextStep(currentStepId);
                    close();
                }
            } }, layoutProps))) : null));
};
const mapStateToProps = (state) => {
    const layout = selectors_1.default.stepLayout.getStepLayoutLayout(state);
    return {
        layout,
        payload: selectors_1.default.stepLayout.getStepLayoutPayload(state),
        user: selectors_1.default.user.getUser(state),
        isTherapySession: selectors_1.default.stepLayout.isTherapySession(layout),
    };
};
const mapDispatchToProps = (dispatch) => ({
    close: () => dispatch(redux_1.ActionCreators.stepLayout.closeStepLayout.dispatch()),
    sessionStepTwo: () => dispatch(redux_1.ActionCreators.stepLayout.sessionStepTwo.dispatch()),
});
StepLayout.defaultProps = {
    selectNextStep: undefined,
    currentStepId: undefined
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(StepLayout);
